import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoContent from './InfoContent';

function ViewAction({ eleItem, handleEdit, handleDelete, i, CareAddEditAccess, CareDeleteAccess }) {
  const { t } = useTranslation('common');

  return (
    <>
      {CareAddEditAccess && (
        <button
          title={t('CARE_LABELS.TABLE.VIEW_ACTION.EDIT')}
          type="button"
          onClick={() => handleEdit(eleItem?._id, i)}
          className="filter-btn filter-button_delete"
        >
          <i className="icon-edit" />
        </button>
      )}
      {CareDeleteAccess && (
        <button
          title={t('CARE_LABELS.TABLE.VIEW_ACTION.DELETE')}
          type="button"
          onClick={() => handleDelete(eleItem?._id)}
          className="filter-btn filter-button_delete"
        >
          <i className="icon-delete" />
        </button>
      )}
      <InfoContent eleItem={eleItem} />
    </>
  );
}
export default ViewAction;
